Librarian.Modules.JSON = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["load", "onDataLoaded", "onBeforeRenderItem", "renderItem", "renderSubItem"],

    options: {
        classPrefix: "modules-json-",
        url: "",
        onBeforeRenderItem: null,
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        if ((this.options.url || '').trim().length == 0)
            throw "URL parameter is required";

        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        new Librarian.Request.JSON({
            method: "get",
            url: Librarian.path.getMethodUrl("prx") + "&out=text&url=" + encodeURIComponent(this.options.url),
            onSuccess: this.onDataLoaded,
            onFailure: Librarian.Utils.onFailure
        }).send();
    },

    onDataLoaded: function(data) {
        if (!data)
            return;

        var contEl = $(this.containerEl);
        if (!contEl)
            return;

        contEl.empty();

        var listEl = new Element("ul").injectInside(contEl);
        if (typeOf(data) != "array")
            this.renderItem(data, listEl);
        else {
            for (var i = 0, length = data.length; i < length; i++)
                this.renderItem(data[i], listEl);
        }
    },

    onBeforeRenderItem: function(item) {
        if (typeof this.options.onBeforeRenderItem == "function")
            return this.options.onBeforeRenderItem(item);
        return true;
    },

    renderItem: function(item, listEl) {
        if (!item)
            return;

        var header = (item.header || '').trim();
        if (header.length > 0) {
            var headerEl = new Element("li", {
                "class": "rss-feed"
            }).injectInside(listEl);
            new Element("h2", {
                "text": header
            }).injectInside(headerEl);
        }

        if (!item.items)
            return;

        for (var i = 0, length = item.items.length; i < length; i++)
            this.renderSubItem(item.items[i], listEl);
    },

    renderSubItem: function(item, listEl) {
        if (!item || !this.onBeforeRenderItem(item))
            return;

        var contEl = new Element("li", {
            "class": "rss-feed"
        }).injectInside(listEl);

        var headerEl = new Element("h2").injectInside(contEl);
        var linkEl = new Element("a", {
            "href": item.link || '#',
            "target": "_blank"
        }).injectInside(headerEl);
        new Element("span", {
            "class": "rss-title content-header",
            "text": (item.title || '').trim()
        }).injectInside(linkEl);

        var subTitle = (item.subTitle || '').trim();
        if (subTitle.length > 0) {
            new Element("div", {
                "class": "rss-date",
                "text": subTitle
            }).injectInside(headerEl);
        }

        var bodyEl = new Element("div", {
            "class": "rss-content"
        }).injectInside(contEl);
        var nodeEl = new Element("div", {
            "class": "node-body article-body"
        }).injectInside(bodyEl);
        new Element("p", {
            "text": (item.text || '').trim()
        }).injectInside(nodeEl);
    }
});